<template>
	<Panel :contentPaddingTop="12">
		<search @onSubmit="onSubmit" />
		<tab :params="params" ref="tableRef" />
	</Panel>
</template>
<script>
import search from './components/search.vue';
import tab from './components/table.vue';
export default {
	name: 'record',
	components: {
		search,
		tab,
	},
	data() {
		return {
			params: {},
		};
	},
	mounted() {
		this.$refs.tableRef.getList();
	},
	methods: {
		onSubmit(data) {
			this.params = data;
			this.$nextTick(() => {
				this.$refs.tableRef.getList();
			});
		},
	},
};
</script>
<style scoped></style>
